import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '@/utils/api';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSent, setIsSent] = useState(false);

  const handleReset = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    try {
        // Tembak API Backend (Logic tidak diubah)
        const response = await fetch(`${API_BASE_URL}/auth/forgot-password`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email })
        });

        const data = await response.json();

        if (response.ok) {
            setIsSent(true);
        } else {
            alert(data.message || 'Gagal mengirim email.');
        }
    } catch (error) {
        alert('Gagal terhubung ke server.');
    } finally {
        setIsLoading(false);
    }
  };

  return (
    <div style={{
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        background: '#F5F5F5', // Latar belakang abu-abu terang sesuai gambar
        fontFamily: "'Poppins', sans-serif" // Pastikan font sesuai style modern
    }}>
      <div style={{
          width: '100%', 
          maxWidth: '550px', 
          background: '#ffffff',
          borderRadius: '30px', 
          padding: '50px', 
          boxShadow: '0 10px 30px rgba(0,0,0,0.05)', // Bayangan halus
          position: 'relative'
      }}>
        
        {/* Tombol Back di pojok kiri atas */}
        <div style={{ marginBottom: '30px', textAlign: 'left' }}>
            <Link to="/auth/login" style={{
                textDecoration: 'none', 
                color: '#000', 
                fontWeight: '600', 
                display: 'inline-flex', 
                alignItems: 'center',
                fontSize: '16px'
            }}>
                <span style={{ marginRight: '8px', fontSize: '20px' }}>←</span> Back
            </Link>
        </div>

        {!isSent ? (
            <div style={{ textAlign: 'center' }}>
                <h2 style={{
                    color: '#1a1a1a', 
                    fontSize: '32px', 
                    fontWeight: '800', 
                    marginBottom: '15px',
                    marginTop: '0'
                }}>
                    Forgotten your password?
                </h2>
                
                <p style={{
                    color: '#666', 
                    fontSize: '16px', 
                    lineHeight: '1.5', 
                    marginBottom: '40px',
                    padding: '0 20px'
                }}>
                    There is nothing to worry about, we’ll send you a message to help you reset your password.
                </p>

                <form onSubmit={handleReset} style={{ textAlign: 'left' }}>
                    <label style={{
                        display: 'block', 
                        fontWeight: '700', 
                        marginBottom: '8px', 
                        color: '#333'
                    }}>
                        Email
                    </label>
                    <input 
                        type="email" 
                        placeholder="Enter personal or work email address" 
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        style={{
                            width: '100%', 
                            padding: '16px', 
                            marginBottom: '30px', 
                            borderRadius: '12px', 
                            border: '1px solid #E0E0E0', 
                            fontSize: '16px',
                            color: '#333',
                            outline: 'none',
                            boxSizing: 'border-box'
                        }} 
                    />
                    
                    <button type="submit" disabled={isLoading} style={{
                        width: '100%', 
                        padding: '18px', 
                        background: '#FF0000', // Warna merah sesuai gambar
                        color: 'white', 
                        border: 'none', 
                        borderRadius: '12px', 
                        fontSize: '16px',
                        fontWeight: 'bold', 
                        cursor: isLoading ? 'not-allowed' : 'pointer',
                        opacity: isLoading ? 0.7 : 1,
                        transition: 'background 0.3s'
                    }}>
                        {isLoading ? 'Sending...' : 'Send Reset Link'}
                    </button>
                </form>
            </div>
        ) : (
            // Tampilan Sukses (tetap mempertahankan style card baru)
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
                <div style={{ fontSize: '50px', marginBottom: '20px' }}>✉️</div>
                <h2 style={{ color: '#1a1a1a', fontWeight: '800', marginBottom: '10px' }}>Check your Email!</h2>
                <p style={{ color: '#666' }}>We have sent a password recover instructions to <b>{email}</b>.</p>
                
                <Link to="/auth/login" style={{
                    display: 'block', 
                    marginTop: '30px', 
                    color: '#FF0000', 
                    fontWeight: 'bold',
                    textDecoration: 'none'
                }}>
                    Back to Login
                </Link>
            </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;